React = require 'react'
Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
l = require 'app/scripts/lib/localize'
Promise = require 'bluebird'
$ = require 'jquery'
{ Apdex } = require '@trello/atlassian-analytics'
log = require 'app/scripts/debug/log'
_ = require 'underscore'
assert = require 'app/scripts/lib/assert'
ApiError = require 'app/scripts/network/api-error'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ trackGTMEvent, trackUe, Noun, Verb } = require '@trello/analytics'
{ memberRoutesViewLoaders } = require './member-routes-view-loaders'
Util = require 'app/scripts/lib/util'
{ Storage } = require '@trello/storage'
TrelloPerf = require('app/common/debug/perf').default
PerfKeys = TrelloPerf.Keys
{ featureFlagClient } = require '@trello/feature-flag-client'
{ renderTopLevelComponent } = require 'app/scripts/controller/renderTopLevelComponent'
{ unlessRouteChanged } = require 'app/scripts/controller/unlessRouteChanged'
{ Campaigns, MoonshotSteps } = require 'app/common/data/campaigns'
{ LazyActionableTaskView } = require 'app/src/components/ActionableTaskView'

# Variables used to determine if we should pretend the user is new, for testing
# purposes
simulateNewUser = null

# keeps track if the browser forward or back buttons are used
browserNav = false
$(window).on 'popstate', ->
  browserNav = true

# keeps track of whether we redirected on initial page load
isInitial = false

module.exports =
  routes: [
    ['', 'memberHomeView']
    [':orgname/home', 'memberHomeBoardsView']
    [':orgname/highlights', 'memberTeamHighlightsView']
    [':orgname/reports', 'teamReportsGateCheck']
    [':username/boards', 'memberAllBoardsView']
    [':username/cards', 'memberCardsView']
    [':username/cards/:orgname', 'memberCardsView']
    [':username/notifications', 'memberNotificationsView']
    [':username/activity', 'memberActivityView']
    [':username/tasks', 'memberActionableView']
  ]

  teamReportsGateCheck: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', 'loadOrganizationMinimal', orgname
      .then (organization) =>
        if @isMemberOfOrg(orgname) && organization.belongsToRealEnterprise() && featureFlagClient.get('enterprise.reports', false)
          @teamReportView(organization)
        else
          @navigate(@getMemberOrgUrl(orgname, true), { trigger: true, replace: true })
      .catch ApiError, =>
        @displayErrorPage()
        return

  teamReportView: (organization) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    { TeamReportPage } = require 'app/src/components/TeamReportPage'

    renderTopLevelComponent(
      React.createElement(TeamReportPage, {
        teamName: organization.get('name'),
        teamId: organization.id,
        modelCache: ModelCache
      })
    )

    trackUe({
      category: Noun.HOME,
      verb: Verb.OPENS,
      directObj: Noun.TEAM_REPORTS_PAGE,
      method: 'by clicking reports under the team name on the sidebar',
      context: {
        idorganization: organization.id,
      },
    })

  displayMemberPage: (settings) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    MemberHomeView = require 'app/scripts/views/member/member-home-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    { username, loadFn, viewClass, getLocation, bodyClass, product, orgname, titleKey, showHomeBoardsTab, templatesData } = settings
    username ?= Auth.myUsername()

    log('controller', ['memberHomeView'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', loadFn, username
      .then (member) =>
        # Wait for the feature flags to be initialized
        featureFlagClient.client.waitUntilReady().then =>
          # If a user is already enrolled in the moonshot campaign, redirect
          # them there to finish the flow
          if member.campaignIsActive(Campaigns.MOONSHOT) &&
           featureFlagClient.get('btg.moonshot', false)
            campaign = member.getCampaign(Campaigns.MOONSHOT)
            # One step is not on /create-first-team, so don't redirect if there
            if campaign.currentStep != MoonshotSteps.WELCOME
              return @navigate '/create-first-team', { trigger: true }

          memberHasNoBoards = member.boardList.length == 0
          memberHasNoOrgs = member.organizationList.length == 0
          simulateNewUser ?= $.cookie('simulateNewUser')
          isNewUser = simulateNewUser ||
            Util.idToDate(Auth.myId()) > Util.dateBefore({ days: 7 })

          if viewClass == MemberHomeView &&
           isNewUser &&
           memberHasNoBoards &&
           memberHasNoOrgs &&
           !member.campaignIsDismissed(Campaigns.MOONSHOT) &&
           !Auth.me().isDismissed('create-first-board')
            nextPath =
              if getExperiment('moonshotDirectSignup').get('variation') == 'enabled' &&
               featureFlagClient.get('btg.moonshot', false)
                '/create-first-team'
              else if featureFlagClient.get('activation.onboarding_v2', false)
                '/welcome'
              else
                '/create-first-board'
            return @navigate nextPath, { trigger: true }

          @clearPreviousView()
          @setViewType(member)

          title =
            if Auth.isMe(member) && titleKey?
              l(['page title', titleKey])
            else
              member.getMemberViewTitle()

          # Do this before creating the view, in case the view has more
          # specific logic for setting the URL
          @setLocation
            title: title
            location: getLocation.call(@, member.get('username'), product)
            options:
              replace: true

          options = { product, orgname, modelCache: ModelCache, showHomeBoardsTab, templatesData }

          memberView = @topLevelView(viewClass, member, options)
          @showHeader(@headerOptsForHome(options))
          @maybeShowFooterChrome(@getMemberBoardsUrl(member.get('username'), orgname, showHomeBoardsTab, templatesData))

          if bodyClass
            $('#trello-root').addClass(bodyClass)
          else
            $('#trello-root').addClass('body-tabbed-page')

          $('#content').html(memberView.render().el)
          @focusContent()
          memberView.getData?()

          return
      .catch ApiError, =>
        @displayErrorPage()
        return

  headerOptsForHome: ({ orgname, modelCache }) ->
    return {} unless orgname && modelCache
    organization = modelCache.findOne('Organization', 'name', orgname)
    if organization?.get('idEnterprise')? && organization?.getEnterprise()?
      enterprise = organization.getEnterprise()
      {
        headerBrandingColor: enterprise.get('prefs')?.brandingColor
        headerBrandingLogo: enterprise.getHeaderLogo()
        headerBrandingName: enterprise.get('displayName')
      }
    else
      {}

  memberTeamHighlightsView: (orgname) ->
    opts = {
      orgname: orgname,
      showHomeBoardsTab: false
    }
    @memberHomeView(opts)

  templatesGalleryLoggedIn: (category, templateSlug, referrerUsername) ->
    shortLink = _.last(if templateSlug? then templateSlug.split('-') else [])
    if templateSlug && (!shortLink? || !Util.isShortLink(shortLink))
      @navigate '/templates', replace: true, trigger: true
      return
    opts = {
      titleKey: 'templates',
      orgname: null,
      showHomeBoardsTab: false,
      templatesData: {
        category: category,
        templateSlug: templateSlug,
        shortLink: shortLink
        referrerUsername: referrerUsername
      }
    }
    @memberHomeView(opts)

  memberAllBoardsView: (username) ->
    # caught by ':username/boards' route
    # but we actually want to show the 'memberHomeView'
    # just without any organisation, to show the SH all boards tab
    opts = {
      orgname: null,
      showHomeBoardsTab: true
    }
    @memberHomeView(opts)

  memberHomeBoardsView: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    # Error early for not-logged-in users
    if !Auth.isLoggedIn()
      # a not-logged-in user cannot be a member of any board
      return @displayErrorPage()

    # Redirect early for non-existent orgs, before trying to load models
    ModelCache.waitFor 'Member', Auth.myId(), =>
      if !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      # this is will show the org boards
      # adding these model loaders so we can show org boards that the user isn't a member of
      ModelLoader.release 'top-level'
      unlessRouteChanged(
        ModelLoader.for 'top-level', 'loadOrganizationBoardsData', orgname
      ).then (org) =>
        opts = {
          orgname: orgname,
          showHomeBoardsTab: true
        }
        @memberHomeView(opts)
      .catch -> null

  memberHomeView: (options = {}) ->
    { orgname, showHomeBoardsTab, templatesData, titleKey } = options
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    MemberHomeView = require 'app/scripts/views/member/member-home-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    if !Auth.isLoggedIn()
      # Hopefully you're not being routed here if you aren't logged in and
      # the server is sending you to the home page
      return @displayErrorPage()

    apdexTask = switch
      when showHomeBoardsTab then 'memberBoards'
      else 'memberHome'
    perfKey = switch
      when showHomeBoardsTab then PerfKeys.BOOTSTRAP_SUPERHOME_VIEW
      when templatesData then PerfKeys.BOOTSTRAP_IN_APP_GALLERY_VIEW
      else PerfKeys.BOOTSTRAP_HOME_VIEW
    Apdex.start(task: apdexTask) unless templatesData
    TrelloPerf.startMeasurement(perfKey)

    ModelCache.waitFor 'Member', Auth.myId(), =>
      lastHomeTab = @getHomeLastTab()
      # if there is no orgname or it's not on all boards tab then it means we are on '/'
      # in that case if there is a last home tab that isn't '/' we want to redirect to that
      if !orgname && !showHomeBoardsTab && !templatesData && lastHomeTab && lastHomeTab != '/' && !browserNav
        browserNav = false

        # When a user lands on `/` and immediately gets redirected to `/:username/boards`,
        # we want to treat that as an "initialLoad" rather than a "transition" for Apdex
        # purposes. We need to explicitly tell the Apdex client this information, since
        # the URL change makes it look like we're doing a client-side transition even
        # though this the first rendered page the user is seeing.
        Apdex.cancel(task: apdexTask)
        isInitial = Apdex.isInitialLoad && Apdex.initialUrl == window.location.href

        return @navigate lastHomeTab, { trigger: true, replace: true, shouldTrack: false }
      else if browserNav
        # if navigating with browser nav buttons then we need to set the last tab
        Storage.set(@getHomeLastTabStorageKey(), window.location.pathname)

      if orgname && !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      @trackMemberHomeView(orgname, showHomeBoardsTab, templatesData)

      browserNav = false
      # If you're logged in, always kick you to your own boards page, since you
      # can't see anyone elses
      simulateNewUser ?= $.cookie('simulateNewUser')
      opts =
        username: 'me'
        # we are using loadMinimumMemberDataForTemplatePage here to fetch the minimum
        # amount of member data so that we pre-cache the apollo cache. This avoids
        # making excessive requests when UpgradePromptQuery is called further down
        # the component tree
        loadFn: if !orgname && !showHomeBoardsTab && templatesData then 'loadMinimumMemberDataForTemplatePage' else 'loadMemberBoardsData'
        viewClass: MemberHomeView
        getLocation: (username) =>
          @getMemberBoardsUrl(username, orgname, showHomeBoardsTab, templatesData)
        titleKey: titleKey || 'boards'
        orgname: orgname
        showHomeBoardsTab: showHomeBoardsTab
        templatesData: templatesData

      @displayMemberPage(opts)
        .then(=>
          title = if typeof orgname == 'undefined'
            l(['page title', 'home'])
          else if !orgname && showHomeBoardsTab
            l(['page title', 'boards'])
          else
            ModelCache.findOne('Organization', 'name', orgname)?.get('displayName')
          @title(title)
        )
        .tap ->
          if apdexTask != 'memberBoards' then return

          if isInitial then Apdex.resetInitialState()
          Apdex.stop(task: apdexTask)

          TrelloPerf.stopMeasurement(perfKey)
          TrelloPerf.reportStartupMetrics()

          isInitial = false
        .done()

      if( simulateNewUser || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
        trackGTMEvent({
          event: 'trello.possibleNewSignup'
        })

  getHomeDefaultTab: ->
    @getMemberBoardsUrl(Auth.myUsername(), null, true)

  getHomeLastTabStorageKey: ->
    "home_#{Auth.myId()}_last_tab_2"

  getHomeLastTab: ->
    Storage.unset("home_#{Auth.myId()}_last_tab") # Clean up old key

    defaultTab = @getHomeDefaultTab()
    lastHomeTab = Storage.get(@getHomeLastTabStorageKey())

    if !lastHomeTab?
      return defaultTab

    if !(lastHomeTab == '/' || lastHomeTab.endsWith('/boards') || lastHomeTab.endsWith('/home'))
      # Clear out any invalid values
      Storage.unset(@getHomeLastTabStorageKey())
      return defaultTab

    return lastHomeTab

  redirectHomeToDefaultTab: ->
    Storage.unset(@getHomeLastTabStorageKey())
    @navigate(@getHomeDefaultTab(), { trigger: true, replace: true })

  isMemberOfOrg: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    orgs = ModelCache.get('Member', Auth.myId())?.getSortedOrgs()
    return orgs.find((org) => org.get('name') == orgname)

  trackMemberHomeView: (orgname, showHomeBoardsTab, templatesData) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    dirObj = ''
    context = {}

    if orgname && showHomeBoardsTab && !templatesData
      dirObj = 'team tab'
      context = {
        teamId: ModelCache.findOne('Organization', 'name', orgname)?.id
      }
    else if !orgname && showHomeBoardsTab && !templatesData
      dirObj = 'boards tab'
    else if !orgname && !showHomeBoardsTab && templatesData
      dirObj = 'templates tab'
    else if !orgname && !showHomeBoardsTab && !templatesData
      dirObj = 'home tab'
    else
      return

    trackUe('home', 'loads', dirObj, '', '', '', context)

  memberProfileView: (username = 'me') ->
    memberRoutesViewLoaders.memberProfile()
    .then (MemberProfileView) =>
      @displayMemberPage
        username: username,
        loadFn: 'loadMemberProfileData'
        viewClass: MemberProfileView
        getLocation: @getMemberProfileUrl
        titleKey: 'profile'
      .done()

  memberActivityView: (username = 'me') ->
    memberRoutesViewLoaders.memberActivity()
    .then (MemberActivityView) =>
      @displayMemberPage
        username: username,
        loadFn: 'loadMemberProfileData'
        viewClass: MemberActivityView
        getLocation: @getMemberActivityUrl
        titleKey: 'activity'
      .done()

  memberCardsView: (username = 'me', orgname) ->
    memberRoutesViewLoaders.memberCards()
    .then (MemberCardsView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberCardsData'
        viewClass: MemberCardsView
        getLocation: (username) =>
          @getMemberCardsUrl(username, orgname)
        titleKey: 'cards'
        orgname: orgname
      .done()

  memberAccountView: (username) ->
    username = 'me'
    memberRoutesViewLoaders.memberAccount()
    .then (MemberAccountView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberAccountData'
        viewClass: MemberAccountView
        getLocation: @getMemberAccountUrl
        titleKey: 'settings'
      .done()

  memberBillingView: (username) ->
    username = 'me'
    featureFlagClient.client.waitUntilReady().then =>
      loader = if featureFlagClient.get('fv.billing-v2', false) then 'memberBilling' else 'memberBillingLegacy'
      memberRoutesViewLoaders[loader]().then (MemberBillingView) =>
        @displayMemberPage
          username: username
          loadFn: 'loadMemberBillingData'
          viewClass: MemberBillingView
          getLocation: @getMemberBillingUrl
          titleKey: 'billing'
        .done()

  memberActionableView: (username) ->
    username = 'me'
    if featureFlagClient.get('remarkable.actionable-view', false)
      renderTopLevelComponent(React.createElement(LazyActionableTaskView))
    else
      @navigate '/', replace: true, trigger: true
